export default __webpack_public_path__ + "static/6-c64356d698ab831619205944d7b11d89.jpg";